import { LoadingLogo } from "Developers/EstebanCaccin/components/LoadingLogo/LoadingLogo";
import { useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useLoginForm } from "./useLoginForm";

import "./loginForm.scss";

export type TLoginForm = {
  typeForm: "login" | "register";
  closeModal?: () => void;
};

export const LoginForm = ({ typeForm, closeModal }: TLoginForm) => {
  const {
    user,
    handleChange,
    loading,
    spinner,
    handleSubmitState,
    success,
    setSuccess
  } = useLoginForm({ typeForm, closeModal });

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(false);
      }, 2000);
    }
  }, []);

  return (
    <Form className='login-form'>
      <Form.Group
        className='mb-3 text-start'
        controlId={`formBasicEmail${typeForm}`}>
        <Form.Control
          name='email'
          value={user.email}
          onChange={handleChange}
          type='email'
          placeholder='Ingresa tu email'
        />
      </Form.Group>

      <Form.Group
        className='mb-3 text-start'
        controlId={`formBasicPassword${typeForm}`}>
        <Form.Control
          name='password'
          value={user.password}
          onChange={handleChange}
          type='password'
          placeholder='Ingresa tu contraseña'
        />
      </Form.Group>
      <div className='states d-flex justify-content-center mb-3'>
        {handleSubmitState && (
          <div className={`${success}`}>{handleSubmitState}</div>
        )}
      </div>
      <div className='box-submit d-flex justify-content-center mb-3'>
        {!loading && (
          <Button variant='success' type='submit' onClick={spinner}>
            {typeForm === "login" ? "Entrar" : "Registrarse"}
          </Button>
        )}
        {loading && <LoadingLogo />}
      </div>
    </Form>
  );
};
